import { configureStore } from '@reduxjs/toolkit';
import userReducer from '@/state/user';
import uploadsReducer from '@/state/uploads';
import modalsReducer from '@/state/modals';
import mapFiltersReducer from '@/state/mapfilters';

export const store = configureStore({
  reducer: {
    user: userReducer,
    uploads: uploadsReducer,
    modals: modalsReducer,
    mapFilters: mapFiltersReducer,
  },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
